module.exports = __webpack_public_path__ + "static/covid-45184f6544ca5bcf41f983a9b9a89791.png";